module.exports = __webpack_public_path__ + "static/media/4.Spare Parts of Battery Sprayer.edb4696d.jpg";